var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-input',{attrs:{"type":_vm.multiLine ? 'textarea' : 'text',"float-label":_vm.defaultText,"rows":_vm.multiLine ? 4 : 1,"aria-label":_vm.defaultText},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }